import { styled } from '@mui/material';

import { useState } from 'react';

import { Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

const StyledItem = styled('div')<{
  type: 'high' | 'medium' | 'low';
  hovered: boolean;
}>(({ theme, type, hovered }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  height: '100%',
  width: hovered ? 80 : theme.spacing(4),
  backgroundColor: colorByType[type],
  color: hovered ? 'var(--text-text-alt-color)' : 'transparent',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  transition: 'all .3s',
  justifyContent: 'center',
  boxSizing: 'border-box',
}));

const colorByType = {
  high: 'var(--success-success-icon-primary-color)',
  medium: 'var(--warning-warning-icon-primary-color)',
  low: 'var(--error-error-icon-primary-color)',
};

export type ItemProps = {
  type: 'high' | 'medium' | 'low';
};

export const Item = ({ type }: ItemProps) => {
  const { t } = useI18n();
  const [hovered, setHovered] = useState(false);

  const handleHover = () => {
    setHovered(true);
  };

  const handleBlur = () => {
    setHovered(false);
  };

  return (
    <StyledItem
      type={type}
      hovered={hovered}
      onMouseEnter={handleHover}
      onMouseLeave={handleBlur}
    >
      <Typography>{t(`prototypes:interactive_probability.${type}`)}</Typography>
    </StyledItem>
  );
};
